/**
 * Created by andrey on 01.10.2024
 */

Map2dFences.onEdit = function (x, y, regionName) {
    const neighbours = BorderRenderer.getNeighbours(x, y).concat({ x, y });
    neighbours.forEach((neighbour) => {
        Map2dFences.clearFences(neighbour.x, neighbour.y);
    });

    const region = Map2d.currentMap.regions[regionName];
    if (region) {
        BorderRenderer.place(
            region.positions,
            Map2dFences.imagePlacement,
            {
                regionName,
                part: neighbours
            }
        );
    }

    neighbours.forEach((neighbour) => {
        Map2d.currentMap.decorators.addDecoratorsViews(neighbour.x, neighbour.y);
    });
};

Map2dFences.clearFences = function (x, y) {
    const map = Map2d.currentMap;
    const fences = map.decorators.getDecorators(x, y);
    if (fences) {
        fences.filter((fence) => fence.regionName).forEach((fence) => {
            map.decorators.removeDecorator(fence.x, fence.y, fence);
            const view = fence.getView();
            if (view) {
                map.onDiscoverMapView().layersViews[view.cell.layer].putTileInPool(view);
            }
        });
    }
};

Map2dFences.toggleAlwaysShort = function (short) {
    if (short === Map2dFences.alwaysShort) {
        return;
    }

    Map2dFences.alwaysShort = short;

    Map2d.currentMap.decorators.iterateDecorators((decorator) => {
        if (!BorderRenderer.BORDERS[decorator.borderName]) {
            return;
        }

        if (short) {
            decorator.setAnimation("idle_short");
        } else {
            decorator.setAnimation("idle");
        }
    });
};
